"use client";

import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";

/**
 * Top-level primary-nav link with an active-page indicator. Client-side
 * so it can read the current pathname: the active item (or its section)
 * gets the accent underline + full-strength label. Hover underline is
 * handled by the passed `className` (CSS), so this only adds the active
 * state on top.
 */
export function EponaNavLink({
  href,
  className,
  children,
  target,
  rel,
}: {
  href: string;
  className: string;
  children: React.ReactNode;
  target?: string;
  rel?: string;
}) {
  const pathname = usePathname() || "/";
  const clean = href && href !== "#" ? href.split("?")[0].replace(/\/$/, "") || "/" : "";
  const active =
    !!clean &&
    (clean === "/"
      ? pathname === "/"
      : pathname === clean || pathname.startsWith(clean + "/"));

  return (
    <Link
      href={href}
      target={target}
      rel={rel}
      aria-current={active ? "page" : undefined}
      className={className}
      style={
        active
          ? { borderBottomColor: "var(--color-accent, #FA8D2A)", color: "#ffffff" }
          : undefined
      }
    >
      {children}
    </Link>
  );
}

export default EponaNavLink;
